import { memo, useEffect, useMemo, useState } from 'react'
import { Link } from 'react-router-dom'
import { SxProps } from '@mui/material'
import { ArrowLongIcon } from '@/assets'
import { Box } from '@/components/Layout'
import { bannerChipsStyles as styles } from './BannerChips.style'
import { bannerChips } from './BannerChips.data'
import { Text } from '@/components/Data'
import { useAppSelector } from '@/redux/core'
import { selectRecentlyVisitedPages } from '@/redux/utils'

function BannerChips() {
  const recentlyVisited = useAppSelector(selectRecentlyVisitedPages)
  const [show, setShow] = useState(false)

  const chips = useMemo(() => {
    const bannerChipsMap = new Map(bannerChips.map((c) => [c.href, c.label]))
    const recentLinks = new Set(recentlyVisited.map((c) => c.href))

    const normalizedRecent = recentlyVisited.map((chip) => ({
      href: chip.href,
      label: bannerChipsMap.get(chip.href) ?? chip.label,
    }))
    const remainingBannerChips = bannerChips.filter((c) => !recentLinks.has(c.href))

    return [...normalizedRecent, ...remainingBannerChips].slice(0, bannerChips.length)
  }, [recentlyVisited])

  // Show chips only after component mounts to prevent hydration mismatch
  useEffect(() => {
    setShow(true)
  }, [])

  if (!show) return <Box component="ul" sx={styles.list} />

  return (
    <Box component="ul" sx={[styles.list, styles.listShow] as SxProps}>
      {chips.map((chip) => (
        <Box key={chip.href} component="li" sx={styles.listItem}>
          <Link to={chip.href} className="link">
            <Box sx={styles.chip}>
              <Text sx={styles.chipText}>{chip.label}</Text>
              <Box sx={styles.arrow} component={ArrowLongIcon} />
            </Box>
          </Link>
        </Box>
      ))}
    </Box>
  )
}

export default memo(BannerChips)
